import { REHYDRATE } from 'redux-persist';
import {
  LEADS_FETCH_BY_ID,
  LEADS_ACTION_CURRENT_STEP
} from '../actions';

const INIT_STATE = {
  lead: null,
  actionsCurrentStep: 0
};

const handler = (state = INIT_STATE, action) => {
  switch (action.type) {
    case LEADS_FETCH_BY_ID.SUCCESS: {
      return { ...state, lead: action.payload }
    }
    case LEADS_ACTION_CURRENT_STEP.REQUEST: {
      return { ...state, actionsCurrentStep: typeof action.payload === 'object' ? 0 : action.payload }
    }
    case REHYDRATE: {
      return INIT_STATE
    }
    default: return { ...state };
  }
}

export default handler
